import DataType from '@opsbase/lib-datatype/DataType';
import doNothing from '@opsbase/lib-general/utils/doNothing';
import i18n from '@opsbase/lib-i18n';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import useAssetUpdate from '@opsbase/react-gql-hooks/asset/useAssetUpdate';
import useOrgFindById from '@opsbase/react-gql-hooks/organisation/useOrgFindById';
import useCallforward from '@opsbase/react-hooks/useCallforward';
import useNewDataActions from '@opsbase/web-ctrl-newdata/useNewDataActions';
import ValueChooser from '@opsbase/web-data-choosers/ValueChooser';
import Divider from '@opsbase/web-layout/Divider';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import AssetTypePicker from '@opsbase/web-pickers/AssetTypePicker';
import DatePicker from '@opsbase/web-pickers/DatePicker';
import TextFieldWithStateAndBlur from '@opsbase/web-textfield/TextFieldWithStateAndBlur/TextFieldWithStateAndBlur';
import { default as React, useCallback, useMemo } from 'react';
import WhereSettingsSection from '../opdefinition/settingssections/WhereSettingsSection';
export function AssetEditOverviewSection(props) {
    var _a;
    const { asset } = props;
    const updateAsset = useAssetUpdate();
    const { updateItemsForType } = useNewDataActions();
    const manuValue = useMemo(() => (!!(asset === null || asset === void 0 ? void 0 : asset.manufacturer) ? [asset === null || asset === void 0 ? void 0 : asset.manufacturer] : []), [asset]);
    const self = useSelf();
    const { data: org } = useOrgFindById({ variables: { id: self.organisationId } });
    const fieldNames = (_a = org === null || org === void 0 ? void 0 : org.settings) === null || _a === void 0 ? void 0 : _a.assetCustomFieldNames;
    const doUpdate = useMemo(() => patch => {
        var _a;
        if ((_a = patch === null || patch === void 0 ? void 0 : patch.places) === null || _a === void 0 ? void 0 : _a.length) {
            patch.places = patch.places.map(p => ({ id: p.id }));
        }
        updateAsset({ id: asset.id, patch })
            .then(a => updateItemsForType(DataType.ASSET, [a]))
            .catch(doNothing);
    }, [asset.id, updateAsset, updateItemsForType]);
    const handleSelectAll = useCallback(() => doUpdate({ places: [] }), [doUpdate]);
    const handleChange = useCallforward(p => v => doUpdate({ [p]: v }), [doUpdate]);
    const handleChangeManufacturer = useCallback(mans => {
        doUpdate({ manufacturer: !!(mans === null || mans === void 0 ? void 0 : mans.length) ? mans[0] : null });
    }, [doUpdate]);
    const handleAddManufacturer = useCallback(v => v, []);
    const availableCustomFields = useMemo(() => {
        if (fieldNames) {
            return Object.keys(fieldNames).filter(k => !!fieldNames[k]);
        }
        return [];
    }, [fieldNames]);
    return useMemo(() => {
        var _a;
        return (React.createElement(Vertical, { padding: true, gutter: true, scroll: true },
            React.createElement(Pane, { visible: true },
                React.createElement(AssetTypePicker, { fullWidth: true, value: (_a = asset === null || asset === void 0 ? void 0 : asset.assetType) === null || _a === void 0 ? void 0 : _a.toString(), onChange: handleChange('assetType') })),
            React.createElement(Divider, null),
            React.createElement(Pane, { visible: true },
                React.createElement(TextFieldWithStateAndBlur, { fullWidth: true, label: i18n.t('description'), value: asset === null || asset === void 0 ? void 0 : asset.description, onBlur: handleChange('description') })),
            React.createElement(Divider, null),
            React.createElement(Pane, { visible: true },
                React.createElement(ValueChooser, { type: DataType.ASSET, fieldName: "manufacturer", value: manuValue, label: i18n.t('manufacturer'), onChange: handleChangeManufacturer, onAddNew: handleAddManufacturer })),
            React.createElement(Pane, { visible: true },
                React.createElement(TextFieldWithStateAndBlur, { fullWidth: true, label: i18n.t('model'), value: asset === null || asset === void 0 ? void 0 : asset.model, onBlur: handleChange('model') })),
            React.createElement(Pane, { visible: true },
                React.createElement(TextFieldWithStateAndBlur, { fullWidth: true, label: i18n.t('serial-no'), value: asset === null || asset === void 0 ? void 0 : asset.serialNo, onBlur: handleChange('serialNo') })),
            React.createElement(Pane, { visible: true },
                React.createElement(DatePicker, { fullWidth: true, label: i18n.t('last-service'), value: asset === null || asset === void 0 ? void 0 : asset.lastServiceDate, onChange: handleChange('lastServiceDate') })),
            React.createElement(Divider, null),
            React.createElement(Pane, { visible: true },
                React.createElement(WhereSettingsSection, { definition: asset, isAsset: true, onChange: doUpdate, onSelectAll: handleSelectAll, isEditable: true })),
            React.createElement(Divider, null),
            availableCustomFields.map((k, idx) => {
                return (React.createElement(Pane, { key: `${k}-${idx}`, hidden: !(fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames[k]) },
                    React.createElement(TextFieldWithStateAndBlur, { fullWidth: true, label: fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames[k], value: asset === null || asset === void 0 ? void 0 : asset[k], onBlur: handleChange(k) })));
            })));
    }, [
        asset,
        handleChange,
        manuValue,
        handleChangeManufacturer,
        handleAddManufacturer,
        doUpdate,
        handleSelectAll,
        availableCustomFields,
        fieldNames,
    ]);
}
export default AssetEditOverviewSection;
